import React from "react";
import styles from "./ViewValidationErrors.module.css";
import ModalView from "@modals/modalview/ModalView";
function ViewValidationErrors({
  isOpen,
  errorsDetected,
  handleReupload,
  onClose,
}: {
  isOpen: boolean;
  errorsDetected: string[];
  handleReupload: () => void;
  onClose: () => void;
}) {
  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.displayErrorContainer}>
        <div className={styles.header}>
          <h2>{"Upload Answer Sheet > Validation Issues"}</h2>
        </div>
        <div className={styles.content}>
          <div className={styles.testListTable}>
            <table>
              <thead>
                <tr>
                  <th>
                    <div className={styles.tableColumn}>
                      <span>S.no.</span>
                    </div>
                  </th>
                  <th>
                    <div className={styles.tableColumn}>
                      <span>Issue Details</span>
                    </div>
                  </th>
                  <th>
                    <div className={styles.tableColumn}>
                      <span>Issue Type</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {errorsDetected?.map((error, index) => (
                  <tr key={index}>
                    <td>{`${index + 1 < 10 ? 0 : ""}${index + 1}`}</td>
                    <td>
                      <span>{error}</span>
                    </td>
                    <td className={styles.issue}>Error</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className={styles.bottomContainer}>
          <p>
            To continue, please resolve all{" "}
            <span className={styles.issue}>{errorsDetected.length}</span>{" "}
            errors.
          </p>
          <div className={styles.buttonContainer}>
            <button className={styles.cancelButton} onClick={onClose}>
              Cancel
            </button>
            <button className={styles.continueButton} onClick={handleReupload}>
              Reupload
            </button>
          </div>
        </div>
      </div>
    </ModalView>
  );
}

export default ViewValidationErrors;
